export const WHAT_MAKES_COURSE_DIFFERENT_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    card_image: "",
    card_color: "#FFFFFF",
    card_title: "Sample Card Title",
    card_title_text_color: "#000000",
    card_description: "Sample card description text",
    card_description_text_color: "#666666",
    priority: 1,
  },

  WHAT_MAKES_COURSE_DIFFERENT_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "What Makes Course Different Title",
      value: "What Makes Our Course Different",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "What Makes Our Course Different",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Sub Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "point_1",
      label: "Point 1",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Point 1",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "point_1_text_color",
      label: "Point 1 Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter point 1 text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "point_1_icon",
      label: "Point 1 Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Point 1 Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "point_1_icon_alt",
      label: "Point 1 Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for Point 1 icon",
      required: false,
      defaultValue: "Point 1",
    },
    {
      fieldName: "point_2",
      label: "Point 2",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Point 2",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "point_2_text_color",
      label: "Point 2 Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter point 2 text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "point_2_icon",
      label: "Point 2 Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Point 2 Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "point_2_icon_alt",
      label: "Point 2 Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for Point 2 icon",
      required: false,
      defaultValue: "Point 2",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_background_color",
      label: "CTA Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_icon",
      label: "CTA Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon_alt",
      label: "CTA Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for CTA icon",
      required: false,
      defaultValue: "Read more",
    },
    {
      fieldName: "cta_shadow_enabled",
      label: "CTA Button Drop Shadow",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable a drop shadow (matches the button colour)",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "carousel_button_color",
      label: "Carousel Button Color",
      value: "#f74958",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter carousel dot active color (e.g., #f74958)",
      required: false,
      defaultValue: "#f74958",
    },
    {
      fieldName: "status",
      label: "What Makes Course Different Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable What Makes Course Different",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card Image",
      fieldName: "card_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Card Image",
      required: true,
    },
    {
      header: "Card Image Alt Text",
      fieldName: "card_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Card Image Alt Text",
      required: false,
    },
    {
      header: "Card Color",
      fieldName: "card_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Color",
      required: false,
    },
    {
      header: "Card Title",
      fieldName: "card_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Card Title",
      required: true,
    },
    {
      header: "Card Title Text Color",
      fieldName: "card_title_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Title Text Color",
      required: false,
    },
    {
      header: "Card Description",
      fieldName: "card_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Card Description",
      required: true,
    },
    {
      header: "Card Description Text Color",
      fieldName: "card_description_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Description Text Color",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};

